import React from 'react';
import { Grid, Box } from '@mui/material';

interface GridLayoutProps {
  left: React.ReactNode;
  main: React.ReactNode;
  right: React.ReactNode;
  isMenuOpen: boolean;
}

const GridLayout = ({
  left,
  main,
  right,
  isMenuOpen
}: GridLayoutProps) => {
  return (
    <Grid container spacing={4}>

      {/* Left Sidebar */}
      {isMenuOpen && (
        <Grid item xs={12} md={2}>
          <Box>{left}</Box>
        </Grid>
      )}

      {/* Main Content */}
      <Grid item xs={12} md={isMenuOpen ? 7 : 9}>
        <Box>{main}</Box>
      </Grid>

      {/* Right Sidebar */}
      <Grid item xs={12} md={3}>
        <Box>{right}</Box>
      </Grid>

    </Grid>
  );
};

export default GridLayout;